(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsListFilterGridDetailPanel', rmsListFilterGridDetailPanel);

    function rmsListFilterGridDetailPanel($timeout) {
        return {
            restrict: 'E',
            scope: {
                options: '=?',
                model: '=?' // should comes from the dataItem. Sometimes the dataItem don't contain enough information. May want to get from remote also.
                // We should also attempt to combine both local data and remote data. First fill in local data. Once api responded with data, we can fill up the rest
            },
            controller: rmsListFilterGridDetailPanelCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/list-filter/grid-detail-panel',
            link: rmsListFilterGridDetailPanelLink
        };

        function rmsListFilterGridDetailPanelLink(scope) {
            const vm = scope.vm;
            $timeout(function() {
                if (typeof vm.submit === typeof function () {}) {
                    vm.showSubmitButton = true;
                }
            });
        }
    }

    function rmsListFilterGridDetailPanelCtrl($scope, lodash, PanelManager, $document, $timeout, $window) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.showSubmitButton = false;
            vm.force_fullwidth = false;
            vm.pageData = {};
            vm.save = save;

            vm.firstRun = true;
            vm.isToggled = false;
            vm.$gridContentWidth = null;

            vm.closePanel = closePanel;
            vm.togglePanel = togglePanel;

            init();
        }

        function init() {
            $scope.listFilterService.sync(vm);
            vm.force_fullwidth = lodash.get(vm.pageData, 'detailPanel.force_fullwidth', false);
            $scope.$watch(function () {
                return $scope.$parent.vm.pageData.sidebar_active || $scope.$parent.vm.pageData.bulk_action_active;
            }, function() {
                $timeout(function() {
                    togglePanel(true);
                }, 150);
            });

            $scope.$watch(function () {
                return  $scope.$parent.vm.pageData.detailPanel.toggleState;
            }, function() {
                $timeout(function() {
                    togglePanel(true);
                }, 150);
            });

            angular.element($window).bind('resize', function(){

                // scope.width = $window.innerWidth;

                // // manuall $digest required as resize event
                // // is outside of angular
                togglePanel(true);
            });
        }

        function save() {
            vm.submit();
        }

        function closePanel() {
            // vm.pageData.detailPanel.toggleState = false;
            $scope.listFilterService.closeDetailPanel();
            if (lodash.has(vm.pageData, 'detailPanel.options.panel_content_id') && lodash.has(vm.pageData, 'detailPanel.options.panel_id')) {
                PanelManager.destroy(vm.pageData.detailPanel.options.panel_id);
            }
        }

        function togglePanel(skipToggle) {
            skipToggle = skipToggle || false;
            // if ($(window).width() < 1000 && vm.firstRun) {
            //     vm.firstRun = false;
            //     return closePanel();
            // }

            vm.firstRun = false;

            if (vm.$gridDetailColumn === undefined) {
                vm.$gridDetailColumn = $('.grid-detail-column');
                vm.$gridContentColumn = vm.$gridDetailColumn.siblings('.grid-content-column');
                vm.$gridContent = vm.$gridContentColumn.find('.k-grid-content');
            }

            var $gridContentWidth = vm.$gridContent.css('width');

            if (vm.force_fullwidth) {
                return;
            }

            // probably need to refactor and figure out what is going on here..
            if (vm.$gridContentWidth === null) {
                vm.$gridContentWidth = $gridContentWidth;
                return;
            }

            if (($gridContentWidth === vm.$gridContentWidth && skipToggle) || lodash.isEmpty(vm.pageData.detailPanel.dataItem)) {
                return;
            }

            vm.$gridContentWidth = $gridContentWidth;
            
            if (!skipToggle) {
                if (!vm.isToggled) {
                    vm.$gridDetailColumn.css('width', 'calc(100% - 30px)');
                } else {
                    vm.$gridDetailColumn.css('width', 'calc(100% - 30px - ' + $gridContentWidth + ')');
                }

                vm.isToggled = !vm.isToggled;
            } else {
                if (!vm.isToggled) {
                    vm.$gridDetailColumn.css('width', 'calc(100% - 30px - ' + $gridContentWidth + ')');
                }
            }
        }
    }
})();